<template>
  <div>
  <!-- <v-container class="container d-flex justify-center"> -->
    <!-- <v-card class="pa-3" style="max-width: 400px; width: 100%"> -->
      <!-- <v-card-title class="outfit-regular">Login with Google</v-card-title> -->
      <!-- <v-card-text> -->
        <v-btn block outlined color="red" class="darken-1" dark @click="googleAuth">
          <v-icon left>mdi-google</v-icon>Continue with Google
        </v-btn>
      <!-- </v-card-text> -->
    <!-- </v-card> -->
  <!-- </v-container> -->
  </div>
</template>
  
<script>
  import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth'
  
  export default {
    name: 'AuthenticateComponent',
    data() {
      return {
        authenticating: false,
        authFeedback: '',
      }
    },
    methods: {
      googleAuth() {
        this.authenticating = true
        this.authFeedback = ''
        const provider = new GoogleAuthProvider()
        provider.addScope('email')
        provider.addScope('profile')
        const auth = getAuth()
        signInWithPopup(auth, provider)
        .then((result) => {
          console.log('Google sign-in successful:', result)
          this.go('RealmDashboard') 
        })
        .catch(error => {
          console.error('Error during Google sign-in:', error)
          this.authFeedback = error.message
          this.authenticating = false
        })
      }
    }
  }
</script>
  
<style lang="scss">

</style>